<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="关注ID">
                  <!-- <el-input style="width: 200px;" v-model="queryForm.followId"></el-input> -->
                  <GridSelectU title="选择任务" style="width: 200px;" labelName="taskName" labelValue="id" :value="queryForm.followId" :limit='1'
                    size='small' placeholder='请选择任务' @getValue="getSeachValueFOLLOW" :columns="TASKFOLLOW_code" :searchs="TASKFOLLOW_search" dataListUrl="/mcn/follow/findList" entityBeanName="mcnTaskFollow" queryEntityUrl="/mcn/follow/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="操作用户的ID">
                  <!-- <el-input  v-model="queryForm.userId"></el-input> -->
                  <GridSelectU title="选择用户" style="width: 200px;" labelName="userName" labelValue="id" :value="queryForm.userId" :limit='1'
                    size='small' placeholder='请选择用户' @getValue="getSeachValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="关注用户的ID">
                  <!-- <el-input  v-model="queryForm.followUserId"></el-input> -->
                  <GridSelectU title="选择用户" style="width: 200px;" labelName="userName" labelValue="id" :value="queryForm.followUserId" :limit='1'
                    size='small' placeholder='请选择用户' @getValue="getSeachValueFollowUserId" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="被催促的用户ID">
                  <!-- <el-input  v-model="queryForm.ergeUserId"></el-input> -->
                  <GridSelectU title="选择用户" style="width: 200px;" labelName="userName" labelValue="id" :value="queryForm.ergeUserId" :limit='1'
                    size='small' placeholder='请选择用户' @getValue="getSeachValueErgeUserId" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMcnTaskFollowRecordList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <!-- <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addMcnTaskFollowRecord"
        >新建</el-button> -->
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editMcnTaskFollowRecord(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteMcnTaskFollowRecord(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          title="下载模板"
          class="icon-box"
          @click="importTemplate"
        >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
        <span
          title="导出数据"
          class="icon-box"
          @click="exportMcnTaskFollowRecordList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshMcnTaskFollowRecordList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="mcnTaskFollowRecordList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="followId"
        label="关注ID"
        width="180"
      >
        <template slot-scope='scope'>
            <div v-if="scope.row.follow">
              {{ scope.row.follow.taskName }}
            </div>
            <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="操作用户的ID"
        width="180"
      >
        <template slot-scope='scope'>
            <div v-if="scope.row.user">
              <div style='text-align: left'>账号：{{ scope.row.user.userName }}</div>
              <div style='text-align: left'>手机：{{ scope.row.user.userMobile }}</div>
              <div style='text-align: left'>昵称：{{ scope.row.user.userNickname }}</div>
              <div style='text-align: left'>姓名：{{ scope.row.user.userRealname }}</div>
            </div>
            <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="followUserId"
        label="关注用户的ID"
        width="180"
      >
        <template slot-scope='scope'>
            <div v-if="scope.row.followUser">
              <div style='text-align: left'>账号：{{ scope.row.followUser.userName }}</div>
              <div style='text-align: left'>手机：{{ scope.row.followUser.userMobile }}</div>
              <div style='text-align: left'>昵称：{{ scope.row.followUser.userNickname }}</div>
              <div style='text-align: left'>姓名：{{ scope.row.followUser.userRealname }}</div>
            </div>
            <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="ergeUserId"
        label="被催促的用户ID"
        width="180"
      > 
        <template slot-scope='scope'>
            <div v-if="scope.row.urgeUser">
              <div style='text-align: left'>账号：{{ scope.row.urgeUser.userName }}</div>
              <div style='text-align: left'>手机：{{ scope.row.urgeUser.userMobile }}</div>
              <div style='text-align: left'>昵称：{{ scope.row.urgeUser.userNickname }}</div>
              <div style='text-align: left'>姓名：{{ scope.row.urgeUser.userRealname }}</div>
            </div>
            <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkMcnTaskFollowRecord(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editMcnTaskFollowRecord(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteMcnTaskFollowRecord(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mcnTaskFollowRecordStates[mcnTaskFollowRecordState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="mcnTaskFollowRecord"
          ref="mcnTaskFollowRecordForm"
          :rules="rules"
          label-width="130px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="关注ID"
            prop="followId"
          >
            <!-- <el-input
              size="small"
              style="width: 200px;"
              v-model="mcnTaskFollowRecord.followId"
              :disabled="mcnTaskFollowRecordState == 'check'"
            ></el-input> -->
            <GridSelectU style="width: 200px;" labelName="taskName" :disabled="mcnTaskFollowRecordState == 'check'"
              labelValue="id" title="选择任务" :value="mcnTaskFollowRecord.followId" :limit='1' size='small' placeholder='请选择任务'
              @getValue="getValueFOLLOW" :columns="TASKFOLLOW_code" :searchs="TASKFOLLOW_search" dataListUrl="/mcn/follow/findList" entityBeanName="mcnTaskFollow" queryEntityUrl="/mcn/follow/get">
            </GridSelectU>
          </el-form-item>
          <el-form-item
            label="操作用户的ID"
            prop="userId"
          >
            <!-- <el-input
              size="small"
              v-model="mcnTaskFollowRecord.userId"
              :disabled="mcnTaskFollowRecordState == 'check'"
            ></el-input> -->
            <GridSelectU style="width: 200px;" labelName="userName" :disabled="mcnTaskFollowRecordState == 'check'"
              labelValue="id" title="选择用户" :value="mcnTaskFollowRecord.userId" :limit='1' size='small' placeholder='请选择用户'
              @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
            </GridSelectU>
          </el-form-item>
          <el-form-item
            label="关注用户的ID"
            prop="followUserId"
          >
            <!-- <el-input
              size="small"
              v-model="mcnTaskFollowRecord.followUserId"
              :disabled="mcnTaskFollowRecordState == 'check'"
            ></el-input> -->
            <GridSelectU style="width: 200px;" labelName="userName" :disabled="mcnTaskFollowRecordState == 'check'"
              labelValue="id" title="选择用户" :value="mcnTaskFollowRecord.followUserId" :limit='1' size='small' placeholder='请选择用户'
              @getValue="getValueFollowUserId" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
            </GridSelectU>
          </el-form-item>
          <el-form-item
            label="被催促的用户ID"
            prop="ergeUserId"
          >
            <!-- <el-input
              size="small"
              v-model="mcnTaskFollowRecord.ergeUserId"
              :disabled="mcnTaskFollowRecordState == 'check'"
            ></el-input> -->
            <GridSelectU style="width: 200px;" labelName="userName" :disabled="mcnTaskFollowRecordState == 'check'"
              labelValue="id" title="选择用户" :value="mcnTaskFollowRecord.ergeUserId" :limit='1' size='small' placeholder='请选择用户'
              @getValue="getValueErgeUserId" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
            </GridSelectU>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mcnTaskFollowRecordState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import { USER,USER_SEARCH,TASKFOLLOW,TASKFOLLOW_SEARCH } from '@/utils/constant.js';
import GridSelectU from '@/components/gridselect';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectU
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMcnTaskFollowRecordList();
                    this.getMcnTaskFollowRecordList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMcnTaskFollowRecordList();
                    this.getMcnTaskFollowRecordList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     followId: '', //关注ID
                     userId: '', //操作用户的ID
                     followUserId: '', //关注用户的ID
                     ergeUserId: '', //被催促的用户ID
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                USER_code: USER,
                USER_search: USER_SEARCH,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                mcnTaskFollowRecordState: 'add',
                mcnTaskFollowRecordStates: {
                    add: '新建互关',
                    check: '查看互关',
                    edit: '修改互关'
                },
                TASKFOLLOW_code: TASKFOLLOW,
                TASKFOLLOW_search: TASKFOLLOW_SEARCH,
                multipleSelection: [],
                mcnTaskFollowRecordList: [],
                mcnTaskFollowRecord: {
                    id: '', //ID
                    followId: '', //关注ID
                    userId: '', //操作用户的ID
                    followUserId: '', //关注用户的ID
                    ergeUserId: '', //被催促的用户ID
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    followId: [{ required: true, message: '关注ID不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '操作用户的ID不能为空', trigger: 'blur' }],
                    followUserId: [{ required: true, message: '关注用户的ID不能为空', trigger: 'blur' }],
                    ergeUserId: [{ required: true, message: '被催促的用户ID不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getMcnTaskFollowRecordList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetMcnTaskFollowRecordList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mcnTaskFollowRecordList = [];
            },
            resetDialog() {
                this.mcnTaskFollowRecordState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      followId: '', //关注ID
                      userId: '', //操作用户的ID
                      followUserId: '', //关注用户的ID
                      ergeUserId: '', //被催促的用户ID
                };
                this.getMcnTaskFollowRecordList();
            },
            // 搜索用户
            getSeachValueUser(value){
              this.queryForm.userId = value
            },
            getSeachValueFOLLOW(value){
              this.queryForm.followId = value
            },
            getValueUser(value) {
              this.mcnTaskFollowRecord.userId = value
            },
            getValueFOLLOW(value) {
              this.mcnTaskFollowRecord.followId = value
            },
            getSeachValueFollowUserId(value){
              this.queryForm.followUserId = value
            },
            getValueFollowUserId(value) {
              this.mcnTaskFollowRecord.followUserId = value
            },
            getSeachValueErgeUserId(value){
              this.queryForm.ergeUserId = value
            },
            getValueErgeUserId(value) {
              this.mcnTaskFollowRecord.ergeUserId = value
            },
            closeDialog() {
                this.showDialog = false
                this.mcnTaskFollowRecord = {
                      id: '', //ID
                      followId: '', //关注ID
                      userId: '', //操作用户的ID
                      followUserId: '', //关注用户的ID
                      ergeUserId: '', //被催促的用户ID
                };
            },
            submitForm() {
                if (this.mcnTaskFollowRecordState == 'add') {
                    this.$refs.mcnTaskFollowRecordForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mcn/followrecord/add`,{ ...this.mcnTaskFollowRecord }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMcnTaskFollowRecordList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.mcnTaskFollowRecordState == 'edit') {
                    this.$refs.mcnTaskFollowRecordForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.mcnTaskFollowRecord.user;
                            delete this.mcnTaskFollowRecord.followUser;
                            delete this.mcnTaskFollowRecord.follow;
                            delete this.mcnTaskFollowRecord.urgeUser;
                            post(`/mcn/followrecord/edit`,{ ...this.mcnTaskFollowRecord }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetMcnTaskFollowRecordList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addMcnTaskFollowRecord() {
                this.showDialog = true;
                this.mcnTaskFollowRecordState = 'add';
            },
            checkMcnTaskFollowRecord(mcnTaskFollowRecordId) {
                console.log(mcnTaskFollowRecordId);
                this.currentMcnTaskFollowRecordId = mcnTaskFollowRecordId;

                this.getMcnTaskFollowRecordById();
                this.showDialog = true;
                this.mcnTaskFollowRecordState = 'check';
            },
            editMcnTaskFollowRecord(mcnTaskFollowRecordId) {
                console.log('mcnTaskFollowRecord', mcnTaskFollowRecordId);
                if (mcnTaskFollowRecordId) {
                    this.currentMcnTaskFollowRecordId = mcnTaskFollowRecordId;
                    this.getMcnTaskFollowRecordById();
                } else {
                    this.mcnTaskFollowRecord = { ...this.mcnTaskFollowRecord, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mcnTaskFollowRecordState = 'edit';
            },
            deleteMcnTaskFollowRecord(mcnTaskFollowRecordId) {
                let ids = '';
                if (mcnTaskFollowRecordId) {
                    ids = mcnTaskFollowRecordId;
                } else {
                    ids = this.multipleSelection.map((mcnTaskFollowRecord) => mcnTaskFollowRecord.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/mcn/followrecord/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMcnTaskFollowRecordList();
                                this.getMcnTaskFollowRecordList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMcnTaskFollowRecordList() {
                this.resetMcnTaskFollowRecordList();
                this.getMcnTaskFollowRecordList();
            },
            getMcnTaskFollowRecordList(query = {}) {
                this.loading = true;
                get(`/mcn/followrecord/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mcnTaskFollowRecordList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getMcnTaskFollowRecordById() {
                get(`/mcn/followrecord/get`,{ id: this.currentMcnTaskFollowRecordId }).then((res) =>{
                    if(res.success){
                      this.mcnTaskFollowRecord = { ...this.mcnTaskFollowRecord, ...res.mcnTaskFollowRecord };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMcnTaskFollowRecordList() {
                //this.btnLoading = true;
                exprotExcel(`/mcn/followrecord/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/mcn/followrecord/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/mcn/followrecord/importData`,formData);
              this.refreshMcnTaskFollowRecordList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMcnTaskFollowRecordList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMcnTaskFollowRecordList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>